import React from 'react';

import dayjs from 'utils/dayjsConfig';

import { formatAtsSnapshot, getOosMechanismLabel, getOosStatusLabel } from './oosLogLabels';

/**
 * @param {Object} props
 * @param {Array<Object>} props.events
 */
export function OosLogTable({ events }) {
    return (
        <table aria-label="Out of stock log events" className="w-full border-collapse text-sm">
            <thead>
                <tr className="border-b bg-muted/40 text-center">
                    <th className="p-2 text-center" scope="col">
                        Timestamp
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Sku - Item name
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Pack Line/Unslotted Item
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Out of Stock/In Stock
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Facility
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Company Source
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Pack Group
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Pack Line
                    </th>
                    <th className="p-2 text-center" scope="col">
                        Details
                    </th>
                    <th className="p-2 text-center" scope="col">
                        On Hand Snapshot
                    </th>
                    <th className="p-2 text-center" scope="col">
                        User
                    </th>
                </tr>
            </thead>
            <tbody>
                {events.map((event, index) => {
                    const skuItemLabel = `${event.externalSku} — ${event.itemName}`;
                    const mechanismLabel = getOosMechanismLabel(event.oosType);
                    const statusLabel = getOosStatusLabel(event.status);
                    const packLineLabel =
                        event.packLineNumber === null || event.packLineNumber === undefined
                            ? '—'
                            : String(event.packLineNumber);
                    const detailsLabel = event.details || '—';
                    const atsLabel = formatAtsSnapshot(event.atsSnapshot);
                    const parsedTimestamp = dayjs(event.timestamp);
                    const timestampLabel = parsedTimestamp.isValid()
                        ? parsedTimestamp.format('YYYY-MM-DD HH:mm:ss')
                        : event.timestamp;
                    const isEvenRow = index % 2 === 1;
                    const cellClassName = isEvenRow ? 'p-2 text-center bg-gray-200' : 'p-2 text-center';

                    return (
                        <tr key={event.id} className="border-b align-top">
                            <td className={`${cellClassName} whitespace-nowrap`}>{timestampLabel}</td>
                            <td className={cellClassName}>{skuItemLabel}</td>
                            <td className={cellClassName}>{mechanismLabel}</td>
                            <td className={cellClassName}>{statusLabel}</td>
                            <td className={cellClassName}>{event.facilityName}</td>
                            <td className={cellClassName}>{event.companySourceName}</td>
                            <td className={cellClassName}>{event.packGroupName}</td>
                            <td className={cellClassName}>{packLineLabel}</td>
                            <td className={cellClassName}>{detailsLabel}</td>
                            <td className={cellClassName}>{atsLabel}</td>
                            <td className={cellClassName}>{event.authUser}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
